"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServerLogger = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _resolve = require("./resolve");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ServerLogger = /*#__PURE__*/function () {
  function ServerLogger(headers) {
    (0, _classCallCheck2.default)(this, ServerLogger);
    (0, _defineProperty2.default)(this, "correlationId", void 0);
    (0, _defineProperty2.default)(this, "communityId", void 0);
    (0, _defineProperty2.default)(this, "userId", void 0);
    (0, _defineProperty2.default)(this, "mainRole", void 0);
    this.correlationId = headers.get('X-Correlation-Id');
    this.communityId = headers.get('X-Consumer-Custom-Id');
    this.userId = headers.get('X-Ins-User-Id');
    this.mainRole = headers.get('X-Ins-Main-Role');
  }

  (0, _createClass2.default)(ServerLogger, [{
    key: "environmentContext",
    get: function get() {
      return {
        region: process.env.AWS_REGION,
        account: process.env.AWS_ACCOUNT_ID,
        service: 'community-backend',
        role: 'frontend',
        environment: process.env.environment
      };
    }
  }, {
    key: "requestContext",
    get: function get() {
      return {
        correlation_id: this.correlationId,
        community_id: this.communityId,
        'X-Consumer-Custom-Id': this.communityId,
        'X-Ins-User-Id': this.userId,
        'X-Ins-Main-Role': this.mainRole,
        'X-Correlation-Id': this.correlationId
      };
    }
  }, {
    key: "error",
    value: function error(_error, context) {
      var _err$stack;

      var err = (0, _resolve.resolveError)(_error);

      var payload = _objectSpread(_objectSpread(_objectSpread({}, this.environmentContext), this.requestContext), {}, {
        level: 'error',
        error_class: "Server".concat(err.name),
        message: err.message,
        fullmessage: ((_err$stack = err.stack) !== null && _err$stack !== void 0 ? _err$stack : err.message).substring(0, 1000)
      }, context); // eslint-disable-next-line no-console


      console.log(JSON.stringify(payload));
    }
  }]);
  return ServerLogger;
}();

exports.ServerLogger = ServerLogger;